import React, { useEffect, useRef, useState } from 'react';
import { Typography, Tooltip } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useNavigate } from 'react-router';
import { getIconStatus } from 'src/app/utils/vehicleService';
import { showLoading } from 'src/features/videoSlice';
import { useDispatch } from 'react-redux';

const VehicleTableCell = props => {
  const { row, index, displayText } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const isMoving = row.device_status === 'moving';

  const icon =
    row.debt === true
      ? '/static/iconSvg/motors/motor_expired.svg'
      : getIconStatus(row.device_status, row.vehicle_type);
  const iconCameraLive = isMoving
    ? `/static/iconSvg/video_motion_active.svg`
    : `/static/iconSvg/video_motion.svg`;

  const safeText =
    displayText && displayText.trim()
      ? displayText
      : row?.license_plate || '--';

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [safeText]);

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          width: '100%'
        }}
      >
        <Box
          style={{
            width: '27px',
            height: '27px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 0 27px'
          }}
        >
          <img
            alt="car"
            src={icon}
            style={{
              width: '100%',
              height: '100%',
              transform: 'rotate(0deg)',
              objectFit: 'contain'
            }}
          />
        </Box>

        <Tooltip
          title={safeText}
          disableHoverListener={!isOverflow}
          arrow
        >
          <Typography
            ref={textRef}
            style={{
              fontSize: '12px',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '120px',
              textAlign: 'left'
            }}
          >
            {safeText}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default React.memo(VehicleTableCell);
